export default __webpack_public_path__ + "static/media/northdokota.05d0c362.jpg";